import { Popover as HeadlessPopover } from "@headlessui/react";
import styled from "styled-components";

import { InlineButton } from "components/atoms/Button";
import { colourScheme, hexToRgba } from "utils/styling/colours";

export const CommentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 100%;
    padding: 0.5rem;
    background: none;
    border-radius: 0.5rem;
`;

export const SortingContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const CommentsSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SortingOption = styled(InlineButton)`
    border: none;
    color: ${colourScheme.white};
    cursor: pointer;
    font-size: 1rem;
    transition: all 0.3s ease;

    &:hover {
        background-color: ${colourScheme.primaryDark};
    }

    &.active {
        border-bottom: 2px solid ${colourScheme.secondary};
    }
`;

export const Popover = styled(HeadlessPopover)`
    position: relative;
`;

export const PopoverButton = styled(HeadlessPopover.Button)`
    background: none;
    color: inherit;
    border: none;
    font-family: inherit;
    font-size: 1rem;
    padding: 0;
    cursor: pointer;
    &:focus {
        outline: none;
    }
`;

export const PopoverPanel = styled(HeadlessPopover.Panel)`
    position: absolute;
    z-index: 10;
    background-color: ${hexToRgba(colourScheme.primaryDark, 0.9)};
    border: 1px solid ${colourScheme.primary};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    top: 100%;
    right: 0;
    padding: 1rem;
    border-radius: 0.5rem;
`;

export const PopoverContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    font-size: 0.7rem;
    max-width: 10rem;
`;
